import config from 'config/Config';
import { initAxios } from 'utils/axios';

export const api = initAxios(config.get('backendURL'));
export const taskApi = initAxios(config.get('backendURL'), 'dt');
export const projectApi = initAxios(config.get('backendURL'), 'projects');
export const cognotaBackendApi = initAxios(
  config.get('backendURL'),
  'cognota-be'
);

// This is used usually for local developent to by pass the proxy service
export const dtApi = initAxios(config.get('dtBackendURL'));
